import { useEffect, useContext } from 'react';
import { UserContext } from '../../context';
import { userLogout } from '../../helpers';
import { logout } from '../../fetch';
import { useAccount, useMsal } from '@azure/msal-react';

export const Logout = () => {
  const { setUser } = useContext(UserContext);

  const { accounts, instance } = useMsal();
  const account = useAccount(accounts[0] ?? {});
  useEffect(() => {
    setUser(null);

    const logoutApiCall = async () => {
      try {
        if (account) {
          instance.logout();
        }
        await logout();
      } catch (e) {}
    };
    logoutApiCall();
    userLogout();
    window.location.href = '/login';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
